import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'react-toastify/dist/ReactToastify.css';
import 'react-calendar/dist/Calendar.css'; // https://github.com/wojtekmaj/react-calendar/blob/main/packages/react-calendar/README.md
import '@/assets/css/index.css';
import '@/assets/css/relatorio.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesProvider from '@/routes';
import { MyProvider } from './shared/contexts/AppProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MyProvider>
      <QueryClientProvider client={queryClient}>
        <RoutesProvider />
      </QueryClientProvider>
    </MyProvider>
  </React.StrictMode >,
);
